<div class="contents-area">
  <div>
    <h1>特集商品提案状況</h1>
    <wj-flex-grid #dtg_FeatureRequestList
      [itemsSource]="model.featureRequestList" [isReadOnly]="true"
      [allowSorting]="true" [headersVisibility]="'Column'" [allowDragging]="'None'"
      [selectionMode]="'Row'" verticalScrollPolicy="'on'" forcedEnabledMode="true">
      <wj-flex-grid-filter #flr_FeatureRequestList></wj-flex-grid-filter>
      <wj-flex-grid-column [header]="'企画回'" [minWidth]="5" [width]="150" [binding]="'CatalogIdName'"></wj-flex-grid-column>
      <wj-flex-grid-column [header]="'媒体'" [minWidth]="5" [width]="250" [binding]="'MediumName'"></wj-flex-grid-column>
      <wj-flex-grid-column [header]="'特集コード'" [minWidth]="5" [width]="120" [binding]="'FeatureCode'"></wj-flex-grid-column>
      <wj-flex-grid-column [header]="'特集名'" [minWidth]="5" [width]="400" [binding]="'FeatureName'"></wj-flex-grid-column>
      <wj-flex-grid-column [header]="'ステータス'" [minWidth]="5" [width]="120" [binding]="'statusName'"></wj-flex-grid-column>
      <wj-flex-grid-column [header]="'備考'" [minWidth]="5" [width]="562" [binding]="'Remarks'"></wj-flex-grid-column>
    </wj-flex-grid>
  </div>
</div>
